import * as THREE from 'three';
import { BaseObject } from './base';

export class Component extends BaseObject {
  constructor() {
    super();
    const group = new THREE.Group();
    return group;
  }
}
